import React from "react";
import { Link } from "react-router-dom";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { history } from "../../app/AppRouter";
import { ArrowDown, ArrowUp } from "../arrowUpDropdown";
import { store } from "../../redux/storeConfig/store";

export const SideDropDown = ({
  title,
  dropdownMenu,
  icon,
  classModal,
  appointmentModal,
  isPages,
  collapsed,
  sideBarCollapsed,
}) => {
  const [isOpen, setIsOpen] = React.useState(
    JSON.parse(sessionStorage.getItem("dd-o")) || false
  );
  const [role, setRole] = React.useState(
    JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).role || null
  );

  React.useEffect(() => {
    sessionStorage.setItem("dd-o", isOpen);
  }, [isOpen]);

  return (
    <li className={`list-element`}>
      <div className="curve">
        <div className="list-element-upper-curve"></div>
      </div>
      <Dropdown isOpen={isOpen} toggle={() => {}} className="flex-column">
        <DropdownToggle onClick={() => setIsOpen(!isOpen)} tag="span">
          <div className="link-blk-dd-toggle">
            <div className="link-data border-btm-dd">
              <div className="link-img">{icon}</div>
              <div className="dropdown-border-bottom">
                <div className="link-text">
                  {!collapsed && (
                    <span style={{ minWidth: "150px" }}>{title}</span>
                  )}
                  <span className="side-DD-Arrow pl-5">
                    {isOpen ? (
                      <ArrowUp color={"#0F172A"} />
                    ) : (
                      <ArrowDown color={"#0F172A"} />
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </DropdownToggle>
        <DropdownMenu style={{ position: "relative" }} id="side-DD">
          {dropdownMenu.map((item) => {
            const havePermission = !item.code || role != "STAFF" ? true :
            (Array.isArray(item.code) ?
            role === "STAFF" &&
            item.code.some(code => store.getState().permissions.permissions[code]) :
            role === "STAFF" &&
            store.getState().permissions.permissions[item.code]);

            if (!havePermission) return;

            if (!isPages)
              return (
                <>
                  <DropdownItem
                    key={item.id}
                    toggle={false}
                    tag="div"
                    className={`list-element`}
                  >
                    <span
                      className="link-blk-dropdown"
                      onClick={
                        item.id === "appointment"
                          ? () => appointmentModal()
                          : () => classModal()
                      }
                    >
                      <span className="link-data">
                        <span className="link-text">
                          {this.props.sideBarCollapsed ? item.icon : item.name}
                        </span>
                      </span>
                    </span>
                  </DropdownItem>
                </>
              );
            else
              return (
                <DropdownItem
                  key={item.id}
                  toggle={false}
                  tag="div"
                  className={`list-element ${
                    history.location.pathname.includes(item.navLink)
                      ? "active"
                      : " "
                  }`}
                >
                  <div className="curve">
                    <div className="list-element-upper-curve"></div>
                  </div>
                  <Link exact to={item.navLink} className="link-blk-dropdown">
                    {sideBarCollapsed ? (
                      <span className="ml-2 mt-2">{item.icon}</span>
                    ) : (
                      <span className="link-data">
                        <span className="link-text">{item.name} </span>
                      </span>
                    )}
                  </Link>
                  <div className="curve-2">
                    <div className="list-element-upper-curve-2"></div>
                  </div>
                </DropdownItem>
              );
          })}
        </DropdownMenu>
      </Dropdown>
      <div className="curve-2">
        <div className="list-element-upper-curve-2"></div>
      </div>
    </li>
  );
};
